import styled, { css } from 'styled-components/macro';

export const StyledMoreButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;

  ${({ theme }) => css`
    color: ${theme.colors.gray[400]};

    &:hover {
      color: ${theme.colors.gray[500]};
    }
  `}
`;
